/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnLeftUpIcon20Light = forwardRef('ArrowDUturnLeftUpIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M.628 7.516a.5.5 0 1 0 .744.669l3.57-3.968A.76.76 0 0 1 5 4.16v6.34a6.5 6.5 0 0 0 13 0v-4a.5.5 0 1 0-1 0v4a5.5 5.5 0 1 1-11 0V4.16c.02.017.04.037.057.057l3.571 3.968a.5.5 0 0 0 .744-.67L6.8 3.549a1.75 1.75 0 0 0-2.602 0L.63 7.516Z" })));
});
